import SearchRoadRoutingRequest, {
  SearchRoadRoutingRequestWaypointCoordinate,
} from "../../../utils/search-road-route/search-road-routing.request";
import OrderOptimizerRoadRouteParams, {
  OrderOptimizerRoadRouteParamsWaypoints,
} from "./order-optimizer-road-route-params";

const changeWaypointType = (
  type: OrderOptimizerRoadRouteParamsWaypoints,
): SearchRoadRoutingRequestWaypointCoordinate => {
  return {
    latitude: type.lat,
    longitude: type.lon,
  };
};

const create = (
  loadParams: OrderOptimizerRoadRouteParams,
): SearchRoadRoutingRequest => {
  return {
    waypointCoordinates: loadParams.waypoints.map(changeWaypointType),
  };
};

const orderOptimizerRoadRouteParamsFactory = {
  create,
};

export default orderOptimizerRoadRouteParamsFactory;
